import { isChatKilledByFlag } from "@/services/analytics/featureFlags";
import { useAuthStore } from "@/stores/auth";

/**
 * Whether this user gets the AI chat assistant at all — the ONE predicate behind every place chat
 * renders (App.vue, SimpleLayout.vue, the /ai-assistance/ai-chat route and its page). Three render
 * sites each carrying their own copy is how the dedicated page was missed twice.
 *
 * - Audit-only accounts never get chat (RAP-588).
 * - An org member without view_pii outside a referring portal: the server 403s all of their chat
 *   (only portal firm chat has a redacted lane), so it is hidden rather than a dead button.
 *   Portal funders DO get it — redacted firm chat (RAP-696), enforced server-side.
 * - The Mixpanel kill switch `ai_chat_disabled` (on = hidden; missing/unreachable = shown).
 * - Otherwise: external (view-assigned) users, or an org with AI enabled.
 *
 * Reactive: reads the auth store and the flag cache, so a computed / template using it updates
 * when either changes.
 */
export function isChatAvailable(): boolean {
  const auth = useAuthStore();
  if (auth.isGrantAuditor || auth.isChatHiddenForNoPii || isChatKilledByFlag()) return false;
  return auth.isExternalUser || auth.isAiEnabled;
}
